import { ErrorMessage, Text } from '@wyz/ui';
import { isNil } from 'lodash-es';
import { Trans } from '~/common/context';
import { IUserCustomer } from '~/common/types';
// eslint-disable-next-line @wyz/module/no-relative-import
import { NoActions } from './no-actions';

type Props = {
  customer?: IUserCustomer;
};

/**
 * Rendered in place of a page the selected point of sale cannot use: either none is selected, or the
 * selected one is not eligible. The wording stays deliberately generic — each caller gates on a
 * different capability, so naming one of them here would be wrong for the others.
 */
export function CustomerEligibilityWarning({ customer }: Props) {
  const isCustomerSelected = !isNil(customer);

  return (
    <>
      <ErrorMessage
        message={
          <Text heading='normal' color='danger'>
            <Trans
              i18nKey={
                isCustomerSelected
                  ? 'app.common.errors.customer_not_eligible'
                  : 'app.purchase.search_page.errors.required_customer.alert'
              }
              components={[<strong key={0} />]}
            />
          </Text>
        }
      />
      <div>
        <NoActions
          title={
            <Trans i18nKey='app.purchase.search_page.errors.required_customer.title' />
          }
          subtitle={
            <Trans
              i18nKey={
                isCustomerSelected
                  ? 'app.common.errors.customer_not_eligible'
                  : 'app.purchase.search_page.errors.required_customer.subtitle'
              }
            />
          }
        />
      </div>
    </>
  );
}
